module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "rowx1 row1"
  }, [_vm._m(0), _vm._v(" "), (_vm.currentRoute.name !== 'SignUp' && _vm.currentRoute.name !== 'Gift' && !_vm.getSiteStatus) ? _c('form', {
    staticClass: "dynamic-box",
    attrs: {
      "id": "footer_form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitEmail.apply(null, arguments)
      }
    }
  }, [(!_vm.user) ? _c('div', {
    staticClass: "col-xs-12 input-group input-md sendrefrel  text-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subscriptionForm.email),
      expression: "subscriptionForm.email"
    }],
    staticClass: "form-control form-control-1",
    attrs: {
      "autocomplete": "email",
      "aria-label": "Sign up for our newsletter",
      "type": "email",
      "placeholder": "Sign up for our newsletter",
      "title": "please enter a valid email address",
      "required": ""
    },
    domProps: {
      "value": (_vm.subscriptionForm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.subscriptionForm, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('div', {
    staticClass: "col-xs-12 input-group input-md sendrefrel  text-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subscriptionForm.email),
      expression: "subscriptionForm.email"
    }],
    staticClass: " form-control form-control-1",
    attrs: {
      "autocomplete": "email",
      "aria-label": "Refer a friend",
      "type": "email",
      "placeholder": "Refer a friend",
      "title": "please enter a valid email address",
      "required": ""
    },
    domProps: {
      "value": (_vm.subscriptionForm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.subscriptionForm, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(2)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "row row1"
  }, [(!_vm.getSiteStatus) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('navbar', {
    staticStyle: {
      "background-color": "transparent"
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/b2b'
      }
    }
  }, [_vm._v("\n                            TONE for Businesses\n                        ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/resources'
      }
    }
  }, [_vm._v("\n                            In the News\n                        ")])], 1), _vm._v(" "), (_vm.showGiftingLinks) ? _c('li', [_c('router-link', {
    attrs: {
      "title": "send gifts",
      "to": {
        path: '/gifts'
      }
    }
  }, [_vm._v("\n                            Give the Gift of Tone\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/Giving'
      }
    }
  }, [_vm._v("\n                            Giving\n                        ")])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/feedback'
      }
    }
  }, [_vm._v("\n                            Feedback\n                        ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/contactus'
      }
    }
  }, [_vm._v("\n                            Contact Us\n                        ")])], 1)])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', {
    staticClass: "margin-bottom-20"
  }, [_c('ul', {
    staticClass: "nav nav-pills"
  }, [_c('li', {
    staticClass: "nav nav-pills footer-compnay-name"
  }, [_vm._v("\n                                © " + _vm._s(_vm.bYear) + " TONE Networks\n                            ")]), _vm._v(" "), (!_vm.getSiteStatus) ? _c('li', {
    staticClass: "active",
    attrs: {
      "role": "presentation"
    }
  }, [_c('router-link', {
    style: ({
      backgroundColor: 'transparent'
    }),
    attrs: {
      "to": {
        path: '/aboutus'
      }
    }
  }, [_vm._v("\n                                About\n                            ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.getSiteStatus) ? _c('li', {
    staticClass: "active",
    attrs: {
      "role": "presentation"
    }
  }, [_c('router-link', {
    style: ({
      backgroundColor: 'transparent'
    }),
    attrs: {
      "to": {
        path: '/privacypolicy'
      }
    }
  }, [_vm._v("\n                                Privacy Policy\n                            ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.getSiteStatus) ? _c('li', {
    staticClass: "active",
    attrs: {
      "role": "presentation"
    }
  }, [_c('router-link', {
    staticClass: "active",
    style: ({
      backgroundColor: 'transparent'
    }),
    attrs: {
      "to": {
        path: '/terms'
      }
    }
  }, [_vm._v("\n                                Terms\n                            ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.getSiteStatus) ? _c('li', {
    staticClass: "active",
    attrs: {
      "role": "presentation"
    }
  }, [_c('router-link', {
    staticClass: "active",
    style: ({
      backgroundColor: 'transparent'
    }),
    attrs: {
      "to": {
        path: '/faq'
      }
    }
  }, [_vm._v("\n                                FAQ\n                            ")])], 1) : _vm._e()])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dynamic-box",
    staticStyle: {
      "border-width": "2px"
    }
  }, [_c('div', {
    staticClass: "input-group input-md float-right"
  }, [_c('img', {
    staticClass: "logo-img",
    attrs: {
      "src": require("../../assets/Footer/footer-logo.png"),
      "alt": "Logo"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon cursor form-control-2"
  }, [_c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Sign Up")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon cursor  form-control-2"
  }, [_c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Send Referral")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dynamic-box"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/tonenetworks/",
      "target": "new",
      "aria-label": "TONE Networks on Facebook (opens in a new window)"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook fa-2x setspace",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.instagram.com/tonenetworks/",
      "target": "new",
      "aria-label": "TONE Networks on Instagram (opens in a new window)"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram fa-2x setspace",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.linkedin.com/company/25037986/",
      "target": "new",
      "aria-label": "TONE Networks on LinkedIn (opens in a new window)"
    }
  }, [_c('i', {
    staticClass: "fa fa-linkedin fa-2x setspace",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dynamic-box"
  }, [_c('div', {
    staticClass: "input-group input-md float-left"
  }, [_c('img', {
    staticClass: "logo-img",
    attrs: {
      "src": require("../../assets/Footer/WOSB-Logo.png"),
      "alt": "Logo"
    }
  })])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4f319b61", module.exports)
  }
}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f319b61"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_test_SLHUyTkZmNS1OnLNdclgNldo"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www1.dev-tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/s3.amazonaws.com/tone-assets/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/layout/Footer.vue